import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { showNotification as showNotificationAction } from "admin-on-rest";
import { userLogin as userLoginAction } from "admin-on-rest";
import GoogleLogin from "react-google-login";

const styles = {
  width: "100%",
  backgroundColor: "#C62828",
  border: "none",
  outline: "none",
  borderRadius: "3px",
  color: "white",
  padding: "1em",
  textAlign: "center",
  textDecoration: "none",
  cursor: "pointer",
  display: "block",
  fontSize: "14px"
};

class LoginButton extends Component {
  responseGoogle = response => {
    console.log("responseGoogle");

    var token = {
      tokenId: response.tokenId,
      accessToken: response.accessToken
    };

    this.props.userLogin(token);
  };

  render() {
    return (
      <GoogleLogin
        clientId="1028406634929-fb86g7voe46ri8dsqhooq55g7j199u7k.apps.googleusercontent.com"
        onSuccess={this.responseGoogle.bind(this)}
        onFailure={this.responseGoogle.bind(this)}
        prompt="select_account"
        style={styles}
      />
    );
  }
}

LoginButton.propTypes = {
  push: PropTypes.func,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction,
  userLogin: userLoginAction
})(LoginButton);



// WEBPACK FOOTER //
// ./src/auth/LoginButton.js